<template>
    <div class="medicine-table">
        <el-table :data="currentRecipe.drugList"
                  border style="width: 100%">
            <el-table-column type="index" min-width="20" align="center"></el-table-column>
            <el-table-column prop="drugName" label="药品名称" min-width="300" align="center">
                <template slot-scope="scope">
                    <el-autocomplete
                            size="small"
                            :trigger-on-focus="false"
                            placeholder="按药品名称或拼音首字母搜索"
                            style="display: inline"
                            v-model="scope.row.drugName"
                            :fetch-suggestions="fetchMedicine"
                            @select="(selectItem) => { handleSelect(selectItem, scope.$index)}"
                    ></el-autocomplete>
                </template>
            </el-table-column>
            <el-table-column prop="perMount" label="单次剂量" min-width="100" align="center">
                <template slot-scope="scope">
                    <el-input size="mini" v-model="scope.row.dosage" min="1"
                    :maxlength="scope.row.dosage>0? 5+(String(parseInt(scope.row.dosage))).length : 6"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="dosageUnit" label="单位" min-width="50" align="center"></el-table-column>
            <el-table-column prop="admission" label="用法" min-width="130" align="center">
                <template slot-scope="scope">
                    <el-select v-model="scope.row.admission" size="small" placeholder="请选择">
                        <el-option
                                v-for="item in drugAdmissionList"
                                :key="item.id"
                                :label="item.dictKey"
                                :value="item.dictKey">
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
<!--            <el-table-column prop="drugOrigin" label="制药公司" min-width="130" align="center">-->
<!--                <template slot-scope="scope"><span>{{scope.row.drugOrigin}}</span></template>-->
<!--            </el-table-column>-->
            <el-table-column prop="drugUnit" label="单位" min-width="50" align="center"></el-table-column>
           <!-- <el-table-column prop="price" label="单价" min-width="50" align="center">
                <template slot-scope="scope">
                    <span>{{scope.row.price?scope.row.price/100:''}}</span>
                </template>
            </el-table-column>-->
<!--            <el-table-column prop="totalPrice" label="金额" min-width="50" align="center">-->
<!--                <template slot-scope="scope" v-if="scope.row.price">-->
<!--                    <span>{{ formatter(scope.row)}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="date" label="操作" align="center">
                <template slot-scope="scope">
                          <span class="color_red fs18 pointer"
                                v-if="scope.$index>0||currentRecipe.drugList.length>1"
                                @click="medicineDelete(scope.$index, scope.row)">x</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
 import {recipeService} from "../../lib/service/recipe";
 import {accAdd, accMul} from "../../lib/filters";

 export default {
    name: "recipe-zhongyao",
    data() {
        return{
            currentRecipe: {},
            patientInfo: {},
            orderType: '',  //'CHINESE_RECIPE' : 'WESTERN_RECIPE'
        }
    },
    props:{
        info: Object,
        patient: Object,
        re: Boolean,
        type: String,
        drugAdmissionList: Array,
        drugFrequencyList: Array,
    },
    methods:{
        //常用方保存
        formatter(data) {
            let price = data.dosage ? accMul(data.price, data.dosage) / 100 : 0;
            let position = String(price).indexOf(".") + 1; //获取小数点的位置
            let count = String(price).length - position; //获取小数点后的个数
            if (position > 0 && count > 2) {
                return accAdd(String(price).substring(0, position + 2), 0.01);
            } else {
                return price;
            }
        },

        handleSelect(item, index){
            this.$emit('handleSelect', item, index)
        },
        medicineDelete(r, i){
            this.$emit('medicineDelete', r)
        },

        async fetchMedicine(queryString, cb) {
            let results = []
            const list = await recipeService.getMedicine({
                orderType: this.orderType,
                dosageForm: this.orderType === 'CHINESE_RECIPE' ? '饮片' : null,
                keyword: queryString,
            })
            if (list.length>0) {
                list.forEach((item) => {
                    item.id && (item.drugId = item.id)
                    //必须绑定value值作为显示数据
                    // item.value =`${item.drugName} `+` ${item.price/100}元/${item.drugUnit} `+` ${item.drugOrigin} `;
                    item.value =`${item.drugName} `;
                })
            }
          // results = queryString.length>1 ?  list : results;
          // cb(results)
          cb(list)
        },
    },
    watch:{
        info:{
            handler(newV){
                this.currentRecipe = newV
            },
            deep: true,
            immediate: true
        },
        patient:{
            handler(newV){
                this.patientInfo = newV
            },
            immediate: true
        },
        type:{
            handler(newV){
                this.orderType = newV
            },
            immediate: true
        },
    }
}
</script>

<style scoped>

</style>
